import { useCallback } from 'react';

import type { Board } from '@/core/schemas';
import { activeTournamentId } from '@/features/tournament/useTournament';
import { subscribeBoards } from '@/infrastructure/repositories/boardRepository';
import { useLiveData, type LiveData } from '@/shared/hooks/useLiveData';

export function useBoards(): LiveData<Board[]> {
  const subscribe = useCallback(
    (onData: (value: Board[]) => void, onError: Parameters<typeof subscribeBoards>[2]) =>
      subscribeBoards(activeTournamentId, onData, onError),
    [],
  );

  return useLiveData<Board[]>(['boards', activeTournamentId], subscribe);
}
